import { getMatchedFields } from './getMatchedFields';
import { CustomFieldDataType } from '../../../../enums/CustomFieldDataType';
import dayjs from 'dayjs';
import { getTransactionType } from '../../../Select/NumberFormat/InlineNumberSelect';

const parseNumberFn = num => ((num || num === 0) ? num : undefined);
const parseDateFn = dateStr => (dateStr ? dayjs(dateStr, 'YYYY-MM-DD') : undefined);

/**
 * zips custom field keys and values from item,
 * item must have keys that are same as custom field keys
 * @param {{}} customFields from state.List.fields {contact:[], transaction:[]}
 * @param {String} tableName editable table name
 * @param {{}} item from setItem
 * @returns {{}} eg {field_1: undefined, field_2: 'value'}
 */
export function getItemFieldObject(customFields, tableName, item) {
    const matchedFields = getMatchedFields(customFields, 'transaction', getTransactionType(tableName));
    // const customFieldKeys = getCustomFieldFormKeys(customFields, 'transaction', getTransactionType(tableName));
    const customFieldKeyValues = matchedFields.reduce((acc, field) => {
        const formKey = `field_${field.id}`;
        let value = item[formKey];
        switch (field.data_type) {
            case CustomFieldDataType.AMOUNT:
                value = parseNumberFn(value);
                break;
            case CustomFieldDataType.DATE:
                value = parseDateFn(value);
                break;
            case CustomFieldDataType.ENUM:
            case CustomFieldDataType.TEXT:
            default:
                break;
        }
        acc[formKey] = value;
        return acc;
    }, {});
    // console.log('aaa custom keyValuePairs', {customFields, item, customFieldKeyValues, matchedFields});
    return customFieldKeyValues;
}
